import { useI18n } from "@excalidraw/excalidraw/i18n";
import { WelcomeScreen } from "@excalidraw/excalidraw/index";
import React from "react";

import { useAtomValue } from "../app-jotai";
import { isRealUser, meAtom, meLoadedAtom } from "../data/me";

export const AppWelcomeScreen: React.FC<{
  isCollabEnabled: boolean;
}> = React.memo(() => {
  const { t } = useI18n();
  const me = useAtomValue(meAtom);
  const meLoaded = useAtomValue(meLoadedAtom);

  // Priority messaging: signing in saves to the server; anonymous work only
  // lives in browser storage. Wait for /api/me so we don't flash the wrong copy.
  const signedIn = meLoaded && isRealUser(me);

  const heading = !meLoaded ? (
    t("welcomeScreen.app.center_heading")
  ) : signedIn ? (
    t("welcomeScreen.app.center_heading_signedIn")
  ) : (
    <>
      <div>{t("welcomeScreen.app.center_heading_signIn")}</div>
      <div style={{ fontSize: "0.85em", opacity: 0.65, marginTop: "0.35em" }}>
        {t("welcomeScreen.app.center_heading_anon")}
      </div>
    </>
  );

  return (
    <WelcomeScreen>
      <WelcomeScreen.Hints.MenuHint>
        {t("welcomeScreen.app.menuHint")}
      </WelcomeScreen.Hints.MenuHint>
      <WelcomeScreen.Hints.ToolbarHint />
      <WelcomeScreen.Hints.HelpHint />
      {meLoaded && !signedIn && (
        <WelcomeScreen.Hints.SignInHint>
          {t("welcomeScreen.app.signInHint")}
        </WelcomeScreen.Hints.SignInHint>
      )}
      <WelcomeScreen.Center>
        <WelcomeScreen.Center.Logo />
        <WelcomeScreen.Center.Heading>{heading}</WelcomeScreen.Center.Heading>
        <WelcomeScreen.Center.Menu>
          <WelcomeScreen.Center.MenuItemLoadScene />
          <WelcomeScreen.Center.MenuItemHelp />
        </WelcomeScreen.Center.Menu>
      </WelcomeScreen.Center>
    </WelcomeScreen>
  );
});
